package org.hs_soft.runmynesto.domain.model.general

enum class SortDirection {
    NONE,
    ASC,
    DESC
}